import { render, staticRenderFns } from "./BLocation.vue?vue&type=template&id=80a9099c&"
import script from "./BLocation.vue?vue&type=script&lang=js&"
export * from "./BLocation.vue?vue&type=script&lang=js&"
import style0 from "./BLocation.vue?vue&type=style&index=0&id=80a9099c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports